import type { App } from 'vue'

export default {
  install(app: App, debugging = true) {
    if (debugging) {
      console.debug = console.debug.bind(console, '%c[debug]', 'color:#00BC7E; line-height:14px;')
    } else {
      console.debug = function () {}
    }
  },
}
